import { useEffect, useRef } from "react";

const SmoothScrollController = () => {
  const headerPlaceholderRef = useRef(null);

  const handleBodyClick = (e) => {
    const link = e.target.closest('a');

    if(link) {
      const linkTarget = link.getAttribute('href');

      if (linkTarget?.startsWith('#')) {
        e.preventDefault();

        const target = document.querySelector(linkTarget);

        if (target) {
          const headerHeight = headerPlaceholderRef.current?.offsetHeight || 0;

          const targetPosition = target.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = targetPosition - headerHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }
    }
  }
  useEffect(() => {
    setTimeout(() => {
      headerPlaceholderRef.current = document.getElementById('header-placeholder');
    }, 200)

    document.body.addEventListener('click', handleBodyClick);

    return () => {
      document.body.removeEventListener('click', handleBodyClick);
    }
  }, [])
}

export default SmoothScrollController;